// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"15125":"2352a5d99ada8ee9df49","25825":"d6211206222f35f62f92","80020":"8d697ea3435a57bd4367"}[chunkId] + ".css";
};